import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class ProductionProcessTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('ProductionProcessTypeReference');
  }
}
